// extracted by mini-css-extract-plugin
export default {"secondaryControlContainer":"SecondaryControls_secondaryControlContainer__WnJsW","controlButton":"SecondaryControls_controlButton__B14Yy"};